import { ButtonLink } from '@/components/Button'
import { HeadingL } from '@/components/Typography'

import { TabWithListStyles } from './styles'
import Tabs from './Tabs'
import type { TabsWithListProps } from './types'

const TabWithListBlock = ({ title, tabs, cta, space }: TabsWithListProps) => (
  <TabWithListStyles spaceOut={space}>
    {title && title.text && (
      <HeadingL className="eu-sm-2" tag={title.tag || 'h3'}>
        {title.text}
      </HeadingL>
    )}
    <div className="eu-sm-4-r">
      <Tabs tabsConfig={tabs} />
    </div>
    {cta && cta.url && (
      <div className="tab-with-list__cta">
        <ButtonLink rounded size="lg" modifier="solid" className="eu-fx-center" source={cta.url}>
          {cta.label}
        </ButtonLink>
      </div>
    )}
  </TabWithListStyles>
)

export default TabWithListBlock
